import(/* webpackMode: "eager" */ "/home/deploy/twin3/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/twin3/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/twin3/components/KoalaIntro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/twin3/components/VhSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/twin3/components/YandexMetrika.tsx");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/@prismicio/next/dist/PrismicNextImage.cjs");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/@prismicio/next/dist/PrismicPreviewClient.cjs");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/@prismicio/next/dist/SliceSimulator.cjs");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/deploy/twin3/node_modules/next/dist/client/script.js");
